if($('.projects.js-sticky-titles').length > 0) {
  // Popup images
  $('article.post').on('mouseover', function () {
    var $src = $(this).find('.title').attr('data-title');
    $('.preview-box').show(); 
    $('.preview').html($src); 
  });

  $('article.post').on('mouseleave', function () {
    $('.preview-box').hide(); 
    $('.preview').html(''); 
  });

  $('body').on('mousemove', function(e) {
    $('.preview-box').offset({
      left: e.pageX + 30,
      top: e.pageY - 15,
    });
  });
}